export { isNonEmptyString } from './isNonEmptyString';
export {
  iosAppVersionGreaterThan,
  iosAppVersionGreaterThanOrEqualTo,
  isIosApp,
} from './stitchfixApp';
export { isLocal } from './isLocal';
export { getParams } from './getParams';
export { themeMapping } from './themeMapping';
export {
  carrierMapping,
  getReturnCarrierLabel,
  RETURN_CARRIER_LABEL_FALLBACK,
} from './carrierMapping';

// Cookies
export const REMEMBER_USER_COOKIE_NAME = 'remember_user_token' as const;
export const ACCEPT_INVITE_COOKIE_NAME = 'referral_redesign_title' as const;

// Feature flags
export const IOS_APP_AUTH_COOKIE_OVERRIDE_FEATURE_FLAG_NAME =
  'client.web.auth_cookie_override_ios_app' as const;

// Fab experiments
export const STYLEFILE_REFRESH_CONFIG_PARAM_NAME =
  'eng.kufak.stylefile_seasonal_refresh' as const;
export const LFF_REMOVE_ITEM_COUNT_MESSAGING_CONFIG_PARAM_NAME =
  'eng.onboarding.lff_remove_item_count_messaging' as const;
export const ADAPTIVE_GIVE_GET_WOMEN_CONFIG_PARAM_NAME =
  'aa.mixer.giveget_recs.women' as const;
export const ADAPTIVE_GIVE_GET_MEN_CONFIG_PARAM_NAME =
  'aa.mixer.giveget_recs.men' as const;
export const GATEWAY_HERO_LAYOUT_CONFIG_PARAM_NAME =
  'eng.onboarding.gateway_hero_layout' as const;

// Max number of household profiles allowed per account, including the primary client
// Source: https://fixops-web.infra.int.stitchfix.com/apps/client-service/environment/production/environment_variables/MAX_HOUSEHOLD_MEMBER_COUNT
export const MAX_HOUSEHOLD_MEMBER_COUNT = 7;
